var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSmallLoader),expression:"showSmallLoader"}],staticClass:"loader-wrap"},[_c('div',{staticClass:"loader-img"})])}
var staticRenderFns = []

export { render, staticRenderFns }